import _, { keyBy } from 'lodash';
import screenerService from '../../../core/services/Tools/Screener/ScreenerService';
import CurrentState from '../../helpers/CurrentState';
import reducerRegistry from '../../helpers/ReducerRegistry';
import userSettingService from './../../../core/services/Common/UserSettingService';
import masterService from './../../../core/services/Common/MasterService';
import ConstCommon from './../../common/Const';
import {
  getDataFollowKeyByDot,
  getDefaultIfEmpty,
} from './../../helpers/Common';
import Const from './Const';
import { I18n } from 'react-redux-i18n';
import { getSortStateParams } from './helper';
import ConstResult from './result/Const';
import { remove } from 'lodash';
import { handleExport } from '../../helpers/HandleExport';

import Validation from '../../helpers/Validation';
// =============================================CONSTANTS=============================================================
const REDUCER_NAME = 'STOCK_SCREENER:';
const FETCH_GET_SCREENER_ITEMS_DATA = `${REDUCER_NAME}FETCH_GET_SCREENER_ITEMS_DATA`;
const CHANGE_WATCH_LIST = `${REDUCER_NAME}CHANGE_WATCH_LIST`;
const CHANGE_SECTOR = `${REDUCER_NAME}CHANGE_SECTOR`;
const CHANGE_CRITERIA = `${REDUCER_NAME}CHANGE_CRITERIA`;
const CHANGE_RANGE = `${REDUCER_NAME}CHANGE_RANGE`;
const LOAD_MORE_DATA = `${REDUCER_NAME}LOAD_MORE_DATA`;
const SUBSCRIBE_REALTIME_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK`;
const FETCH_MY_WATCH_LIST = `${REDUCER_NAME}FETCH_MY_WATCH_LIST`;
const FETCH_USER_SCREENER = `${REDUCER_NAME}FETCH_USER_SCREENER`;
const FETCH_TOP_SCREENER = `${REDUCER_NAME}FETCH_TOP_SCREENER`;

const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const FETCH_SCREENER_PARAMETERS = `${REDUCER_NAME}FETCH_SCREENER_PARAMETERS`;

const TOGGLE_POPUP_SAVE = `${REDUCER_NAME}TOGGLE_POPUP_SAVE`;
const SHOW_MESSAGE_SAVE = `${REDUCER_NAME}SHOW_MESSAGE_SAVE`;

const CHANGE_SCREENER = `${REDUCER_NAME}CHANGE_SCREENER`;
const DELETE_SCREENER = `${REDUCER_NAME}DELETE_SCREENER`;
const CREATE_SCREENER_SUCCESSFUL = `${REDUCER_NAME}CREATE_SCREENER_SUCCESSFUL`;

const GET_INDUSTRY = `${REDUCER_NAME}GET_INDUSTRY`;

const DEFAULT_PAGE_LOAD = 1;

const CHANGE_SORT_STATE = `${REDUCER_NAME}CHANGE_SORT_STATE`;
const SET_PARAMETERS = `${REDUCER_NAME}SET_PARAMETERS`;

// =============================================EXPORT=============================================================
export {
  REDUCER_NAME,
  reducer as default,
  changeWatchList,
  subscribeRealtimeTick,
  fetchMyWatchList,
  changeSector,
  changeCriteria,
  getScreenerParameter,
  changeRange,
  getScreenerData,
  loadMoreData,
  getUserScreeners,
  saveScreener,
  getTopScreeners,
  togglePopupSave,
  togglePopupResponseSave,
  deleteScreener,
  updateScreener,
  changeScreener,
  fetchIndustryData,
  downloadScreener,
  changeSortState,
  setParameters,
};

function setParameters(payload) {
  return {
    type: SET_PARAMETERS,
    payload,
  };
}

function changeSortState(sortState) {
  return {
    type: CHANGE_SORT_STATE,
    payload: sortState,
  };
}

function changeWatchList(watchListId) {
  return dispatch => {
    dispatch({
      type: CHANGE_WATCH_LIST,
      payload: {
        watchListId,
      },
    });
    dispatch(getScreenerData());
  };
}

function changeSector(sectorId) {
  return dispatch => {
    dispatch({
      type: CHANGE_SECTOR,
      payload: {
        sectorId,
      },
    });
    dispatch(getScreenerData());
  };
}

function changeCriteria(criteria) {
  return dispatch => {
    dispatch({
      type: CHANGE_CRITERIA,
      payload: {
        criteria,
      },
    });
  };
}

function changeRange(parameters) {
  return dispatch => {
    if (parameters.length > Const.maxParam) {
      const errors = [I18n.t('stockScreener.screenerMessage.errorMaxParam')];
      dispatch({
        type: SHOW_MESSAGE_SAVE,
        payload: {
          isShowMessage: true,
          messages: errors,
          maxParam: true,
        },
      });
    } else {
      dispatch({
        type: CHANGE_RANGE,
        payload: {
          parameters,
        },
      });
    }
  };
}

function loadMoreData(page) {
  return (dispatch, globalState) => {
    const comGroupCode =
      globalState()[REDUCER_NAME].comGroupCode || Const.defaultWatchList;
    const icbCode = globalState()[REDUCER_NAME].icbCode || Const.defaultIcbCode;
    const parameters = globalState()[REDUCER_NAME].parameters || [];
    const sortState = globalState()[REDUCER_NAME].sortState || {};
    dispatch(setLoading(true));
    screenerService
      .getScreenerItems({
        comGroupCode: comGroupCode,
        icbCode: icbCode,
        parameters: parameters,
        page: page,
        pageSize: Const.itemPerPage,
        ...getSortStateParams(getDefaultIfEmpty(sortState, defaultSortState)),
      })
      .then(({ items }) => {
        if (items) {
          const listScreenerDataMore = items || [];
          dispatch({
            type: LOAD_MORE_DATA,
            payload: {
              listScreenerDataMore,
              page,
            },
          });
        }
        dispatch(setLoading(false));
      });
  };
}

function subscribeRealtimeTick(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK,
    payload: {
      data,
    },
  };
}

function fetchMyWatchList() {
  return dispatch => {
    userSettingService.getUserWatchList().then(({ items }) => {
      if (items) {
        const { listCompany } = getUserWatchListByTypeCode(items);
        dispatch({
          type: FETCH_MY_WATCH_LIST,
          payload: {
            listCompany,
          },
        });
      }
    });
  };
}

function getScreenerParameter() {
  return dispatch => {
    screenerService.getScreenerParameters().then(({ items }) => {
      if (items) {
        dispatch({
          type: FETCH_SCREENER_PARAMETERS,
          payload: {
            items,
          },
        });
      }
    });
  };
}

function getScreenerData(params = {}) {
  return (dispatch, globalState) => {
    const comGroupCode =
      globalState()[REDUCER_NAME].comGroupCode || Const.defaultWatchList;
    const icbCode = globalState()[REDUCER_NAME].icbCode || Const.defaultIcbCode;
    const parameters = globalState()[REDUCER_NAME].parameters || [];
    const sortState = globalState()[REDUCER_NAME].sortState || {};
    const page = DEFAULT_PAGE_LOAD;
    const listHideColumnNew = [...ConstResult.listHideColumn];
    let listShow = [];
    listHideColumnNew.forEach(c => {
      parameters.forEach(p => {
        if (
          p.code.toLowerCase() === c.substring(c.indexOf('.') + 1).toLowerCase()
        ) {
          listShow.push(c);
        }

        if (p.code.toLowerCase() === 'revttm') {
          listShow.push('financial.isa3');
        }

        if (p.code.toLowerCase() === 'isa20ttm') {
          listShow.push('financial.isa20');
        }
      });
    });
    remove(listHideColumnNew, function(n) {
      return listShow.indexOf(n) > -1;
    });
    dispatch(setLoading(true));
    screenerService
      .getScreenerItems({
        comGroupCode: comGroupCode,
        icbCode: icbCode,
        parameters: parameters,
        page: page,
        pageSize: Const.itemPerPage,
        ...getSortStateParams(getDefaultIfEmpty(sortState, defaultSortState)),
        ...params,
      })
      .then(({ items, totalCount }) => {
        if (items) {
          const listScreenerData = items || [];
          const totalRecords = totalCount;
          const totalPage = Math.ceil(totalCount / Const.itemPerPage);
          dispatch({
            type: FETCH_GET_SCREENER_ITEMS_DATA,
            payload: {
              listScreenerData,
              totalRecords,
              totalPage,
              listHideColumn: listHideColumnNew,
            },
          });
        }
        dispatch(setLoading(false));
      });
  };
}

function getUserScreeners() {
  return dispatch => {
    userSettingService.getScreeners().then(({ items }) => {
      if (items) {
        dispatch({
          type: FETCH_USER_SCREENER,
          payload: {
            items,
          },
        });
      }
    });
  };
}

function getTopScreeners() {
  return dispatch => {
    userSettingService.getTopScreeners().then(({ items }) => {
      if (items) {
        dispatch({
          type: FETCH_TOP_SCREENER,
          payload: {
            items,
          },
        });
      }
    });
  };
}

function togglePopupSave(isShow, val) {
  return (dispatch, globalState) => {
    const parameters = globalState()[REDUCER_NAME].parameters;

    if (!parameters || parameters.length === 0) {
      const errors = [I18n.t('stockScreener.screenerMessage.errorEmptyParam')];
      dispatch({
        type: SHOW_MESSAGE_SAVE,
        payload: {
          isShowMessage: true,
          messages: errors,
        },
      });
    } else {
      dispatch({
        type: TOGGLE_POPUP_SAVE,
        payload: {
          isShow,
        },
      });
      if (typeof val !== 'undefined' && isShow) {
        if (val.trim().length > 0) {
          dispatch(saveScreener(val));
        } else {
          const errors = [I18n.t('message.invalid_name_message')];
          dispatch({
            type: SHOW_MESSAGE_SAVE,
            payload: {
              isShowMessage: true,
              messages: errors,
              invalidName: true,
            },
          });
        }
        dispatch({
          type: TOGGLE_POPUP_SAVE,
          payload: {
            isShow: false,
          },
        });
      }
    }
  };
}

function togglePopupResponseSave(isShow, errors) {
  return {
    type: SHOW_MESSAGE_SAVE,
    payload: {
      isShowMessage: isShow,
      messages: errors,
    },
  };
}

function saveScreener(name) {
  return (dispatch, globalState) => {
    const parameters = globalState()[REDUCER_NAME].parameters || [];
    const comGroupCode =
      globalState()[REDUCER_NAME].comGroupCode || Const.defaultWatchList;
    const icbCode = globalState()[REDUCER_NAME].icbCode || Const.defaultIcbCode;
    const criteria = globalState()[REDUCER_NAME].criteria;
    const objectSetting = { comGroupCode, icbCode, criteria, parameters };
    const string = JSON.stringify(objectSetting);

    const validation = new Validation(name);
    let messages = validation
      .isEmpty()
      .startWithAlphabetOrNumber()
      .limitCharacter(100).messages;
    if (messages.length > 0) {
      const errors = [I18n.t('message.invalid_name_message')];
      dispatch({
        type: SHOW_MESSAGE_SAVE,
        payload: {
          isShowMessage: true,
          messages: errors,
        },
      });
    } else {
      userSettingService
        .createScreener({ name: name, settings: string })
        .then(res => {
          const data = res || {};

          switch (data.status) {
            case ConstCommon.RESPONSE_STATUS.FAILED:
              const { errors = [] } = data;
              dispatch({
                type: SHOW_MESSAGE_SAVE,
                payload: {
                  isShowMessage: true,
                  messages: errors,
                },
              });
              break;

            case ConstCommon.RESPONSE_STATUS.SUCCESS:
              const activeScreener = data.result;
              dispatch({
                type: CREATE_SCREENER_SUCCESSFUL,
                payload: {
                  activeScreener,
                  activeScreenerName: name,
                },
              });
              dispatch(getUserScreeners());
              break;
            default:
              break;
          }
        });
    }
  };
}

function deleteScreener(screenerId) {
  return (dispatch, globalState) => {
    userSettingService.deleteScreener({ screenerId: screenerId }).then(res => {
      const data = res || {};
      if (data.status === ConstCommon.RESPONSE_STATUS.SUCCESS) {
        dispatch(getUserScreeners());
        if (globalState()[REDUCER_NAME].activeScreener === screenerId) {
          dispatch({
            type: DELETE_SCREENER,
            payload: {
              activeScreener: '',
              comGroupCode: Const.defaultWatchList,
              icbCode: Const.defaultIcbCode,
              parameters: [],
              criteria: '',
            },
          });
        }
      }
    });
  };
}

function updateScreener(screenerId, name) {
  return (dispatch, globalState) => {
    const validation = new Validation(name);
    let messages = validation
      .isEmpty()
      .startWithAlphabetOrNumber()
      .limitCharacter(50).messages;
    if (messages.length > 0) {
      const errors = [I18n.t('message.invalid_name_message')];
      dispatch({
        type: SHOW_MESSAGE_SAVE,
        payload: {
          isShowMessage: true,
          messages: errors,
        },
      });
    } else {
      const userScreener = globalState()[REDUCER_NAME].userScreener || [];
      const selectScreener = userScreener.find(
        s => s.screenerId === screenerId,
      );
      const string = selectScreener.settings;
      // }
      userSettingService
        .updateScreener({
          screenerId,
          name: name,
          settings: string,
        })
        .then(res => {
          const data = res || {};
          if (data.status === ConstCommon.RESPONSE_STATUS.SUCCESS) {
            dispatch(getUserScreeners());
          } else if (data.status === ConstCommon.RESPONSE_STATUS.FAILED) {
            const { errors = [] } = data;
            dispatch({
              type: SHOW_MESSAGE_SAVE,
              payload: {
                isShowMessage: true,
                messages: errors,
              },
            });
          }
        });
    }
  };
}

function changeScreener(screenerId, isTopScreener) {
  return (dispatch, globalState) => {
    let activeScreener = screenerId;
    let userScreener = globalState()[REDUCER_NAME].userScreener || [];
    let selectScreener = userScreener.find(
      s => s.screenerId === activeScreener,
    );
    if (isTopScreener === true) {
      userScreener = globalState()[REDUCER_NAME].topScreener || [];
      selectScreener = userScreener.find(s => s.screenerId === activeScreener);
      activeScreener = null;
    }
    if (selectScreener) {
      const settings = JSON.parse(selectScreener.settings);
      const { comGroupCode, icbCode, criteria, parameters } = settings;
      dispatch({
        type: CHANGE_SCREENER,
        payload: {
          activeScreener: activeScreener,
          activeScreenerName: selectScreener.name,
          comGroupCode,
          icbCode,
          parameters,
          criteria,
          selectedScreenerId: screenerId,
          isTopScreener,
        },
      });
      dispatch(getScreenerData());
    }
  };
}

function getUserWatchListByTypeCode(listUserWatchList) {
  const result = {
    listCompany: [],
    listSector: [],
  };
  result.listSector.push({
    watchListId: 0,
    text: 'All Sectors',
    code: 'All',
    typeCode: 'Sector',
  });
  result.listCompany.push({
    watchListId: 0,
    text: 'All Exchanges',
    code: 'All',
    typeCode: 'CompanyGroup',
  });
  listUserWatchList.forEach(item => {
    if (item.typeCode === Const.watchListType.COMPANY_GROUP) {
      result.listCompany.push(item);
    }
    if (item.typeCode === Const.watchListType.SECTOR) {
      result.listSector.push(item);
    }
  });

  return result;
}

function fetchIndustryData() {
  return dispatch => {
    masterService.getAllIcbIndustry().then(response => {
      const { items = [] } = response;
      dispatch({
        type: GET_INDUSTRY,
        payload: {
          allSectors: I18n.t('stockScreener.allSectors'),
          listSector: items && items.length ? items : [],
        },
      });
    });
  };
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

function downloadScreener(locale, tab, fileName = 'export-file') {
  return (dispatch, globalState) => {
    const parameters = globalState()[REDUCER_NAME].parameters || [];
    const comGroupCode =
      globalState()[REDUCER_NAME].comGroupCode || Const.defaultWatchList;
    const icbCode = globalState()[REDUCER_NAME].icbCode || Const.defaultIcbCode;
    screenerService
      .getScreenerExport({
        comGroupCode: comGroupCode,
        icbCode: icbCode,
        parameters: parameters,
        language: locale,
        tab: tab,
      })
      .then(response => {
        handleExport(response, fileName);
      });
  };
}

const defaultSortState = { 'StockScreenerItem.Ticker': 'asc' };

const initialState = {
  listScreenerDataTicker: [],
  listObjectScreenerDataByTicker: {},
  sortState: {},

  listWatchListId: [],
  defaultWatchList: '',
  isLoading: false,
  component: {},
  comGroupCode: '',
  icbCode: '',
  criteria: '',
  listSectorDropdown: [],
  listSectorDropdownByKey: {},

  save: {
    isShow: false,
    messages: [],
  },
  maxParam: false,
  invalidName: false,
};

function reducer(globalState = initialState, action) {
  switch (action.type) {
    case TOGGLE_POPUP_SAVE: {
      return {
        ...globalState,
        save: {
          ...globalState.save,
          isShow: action.payload.isShow,
        },
      };
    }

    case SHOW_MESSAGE_SAVE: {
      const {
        isShowMessage,
        messages = [],
        maxParam,
        invalidName,
      } = action.payload;

      return {
        ...globalState,
        maxParam,
        invalidName,
        save: {
          ...globalState.save,
          isShowMessage,
          messages,
        },
      };
    }

    case FETCH_GET_SCREENER_ITEMS_DATA:
      const { totalRecords, totalPage } = action.payload;
      const listScreenerDataTicker = action.payload.listScreenerData.map(
        item => item.stockScreenerItem.organCode,
      );
      const listObjectScreenerDataByTicker = _.keyBy(
        action.payload.listScreenerData,
        'stockScreenerItem.organCode',
      );
      return {
        ...globalState,
        listScreenerDataTicker,
        listObjectScreenerDataByTicker,
        totalRecords,
        totalPage,
        page: DEFAULT_PAGE_LOAD,
        listHideColumn: action.payload.listHideColumn,
      };

    case CHANGE_WATCH_LIST:
      const comGroupCode = action.payload.watchListId;
      return { ...globalState, comGroupCode };

    case CHANGE_SECTOR:
      const icbCode = action.payload.sectorId;
      return { ...globalState, icbCode };

    case CHANGE_CRITERIA:
      const criteria = action.payload.criteria;
      return { ...globalState, criteria };

    case CHANGE_RANGE:
      const { parameters } = action.payload;
      return { ...globalState, parameters };

    case LOAD_MORE_DATA:
      const listScreenerDataTickerMore = action.payload.listScreenerDataMore.map(
        item => item.stockScreenerItem.organCode,
      );
      const listObjectScreenerDataByTickerMore = _.keyBy(
        action.payload.listScreenerDataMore,
        'stockScreenerItem.organCode',
      );

      return {
        ...globalState,
        listScreenerDataTicker: [
          ...globalState.listScreenerDataTicker,
          ...listScreenerDataTickerMore,
        ],
        listObjectScreenerDataByTicker: {
          ...globalState.listObjectScreenerDataByTicker,
          ...listObjectScreenerDataByTickerMore,
        },
        page: action.payload.page,
      };

    case SUBSCRIBE_REALTIME_TICK:
      const listObjectScreenerDataByTickerNew = {
        ...globalState.listObjectScreenerDataByTicker,
      };
      action.payload.data.forEach(item => {
        if (listObjectScreenerDataByTickerNew[item.organCode]) {
          const tickerItem = {
            ...listObjectScreenerDataByTickerNew[item.organCode],
          };

          if (tickerItem) {
            tickerItem.volume = item.totalMatchVolume;
            tickerItem.price = item.matchPrice;
            tickerItem.percentPriceChange = item.percentPriceChange;
            tickerItem.tradingDate = item.tradingDate;
            tickerItem.performance.percentPriceChange1Day =
              item.percentPriceChange;
          }
          listObjectScreenerDataByTickerNew[item.organCode] = tickerItem;
        }
      });
      return {
        ...globalState,
        listObjectScreenerDataByTicker: listObjectScreenerDataByTickerNew,
      };

    case FETCH_MY_WATCH_LIST:
      const { listCompany } = action.payload;

      const listWatchList = listCompany ? [...listCompany] : [];

      const listWatchListId = listWatchList.map(item =>
        getDataFollowKeyByDot(item, Const.watchList.CODE),
      );

      const listWatchListByWatchListId = keyBy(
        listWatchList,
        Const.watchList.CODE,
      );

      return {
        ...globalState,
        listWatchListId,
        listWatchListByWatchListId,
      };

    case FETCH_SCREENER_PARAMETERS:
      return {
        ...globalState,
        listParam: action.payload.items,
      };

    case FETCH_USER_SCREENER:
      return {
        ...globalState,
        userScreener: action.payload.items,
      };

    case FETCH_TOP_SCREENER:
      return {
        ...globalState,
        topScreener: action.payload.items,
      };

    case SET_LOADING:
      return {
        ...globalState,
        isLoading: action.payload,
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...globalState,
        component: action.payload,
      };

    case CHANGE_SCREENER:
      return {
        ...globalState,
        activeScreener: action.payload.activeScreener,
        comGroupCode: action.payload.comGroupCode,
        icbCode: action.payload.icbCode,
        parameters: action.payload.parameters,
        activeScreenerName: action.payload.activeScreenerName,
        criteria: action.payload.criteria,
        selectedScreenerId: action.payload.selectedScreenerId,
        isTopScreener: action.payload.isTopScreener,
      };
    case DELETE_SCREENER:
      return {
        ...globalState,
        activeScreener: action.payload.activeScreener,
        comGroupCode: action.payload.comGroupCode,
        icbCode: action.payload.icbCode,
        parameters: action.payload.parameters,
        criteria: action.payload.criteria,
        listScreenerDataTicker: [],
        listObjectScreenerDataByTicker: {},
      };
    case CREATE_SCREENER_SUCCESSFUL:
      return {
        ...globalState,
        activeScreener: action.payload.activeScreener,
        activeScreenerName: action.payload.activeScreenerName,
      };
    case SET_PARAMETERS:
      return {
        ...globalState,
        parameters: action.payload,
      };
    case GET_INDUSTRY: {
      const { listSector, allSectors } = action.payload;
      const icbLevelHardCode = 3;
      const icbDropdown = 1;
      const listSectorSorted = listSector.filter(
        industry => industry.icbLevel === icbLevelHardCode,
      );

      let listSectorDropdownData = [];
      listSectorDropdownData.push({
        icbCode: 'All',
        icbName: allSectors,
      });
      const listSector1 = listSector.filter(
        industry => industry.icbLevel === icbDropdown,
      );

      listSector1.forEach(item => {
        listSectorDropdownData.push(item);
      });

      const listSectorDropdown = listSectorDropdownData.map(item =>
        getDataFollowKeyByDot(item, 'icbCode'),
      );

      const listSectorDropdownByKey = keyBy(listSectorDropdownData, 'icbCode');
      return {
        ...globalState,
        listSector: listSectorSorted,
        listSectorDropdown,
        listSectorDropdownByKey,
      };
    }

    case CHANGE_SORT_STATE:
      return {
        ...globalState,
        sortState: action.payload,
      };

    default:
      return globalState;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
